<script setup>
    import * as http from '@/libs/http';
    import config from "@/config";
    import { isEmpty,inArray } from "@/libs/utils";

    const URL = config.base_url.replace("/homeapi","");

    const props = defineProps({
        data: {
            type: [Object,Array],
            default: {}
        }
    });
    
    let contentData = ref(props.data.list);
    const isLoading = ref(true);
    watch([()=>props.data],async (newValue,oldValue)=>{
        isLoading.value = false;
    },{ deep: true, immediate: true })
    
    const getContentImage = (value)=>{
      if(value.image != undefined && value.image.length > 0) {
          return value.image;
      }else{
          return URL + '/static/images/menu/empty.png';
      }
    }

</script>

<template>
    <div class="goods-wrap">
      <el-skeleton :loading="isLoading" animated>
            <template #template>
                <div style="display: flex; flex-direction: row; flex-wrap: wrap; width: 1200px; margin: 0 auto;">
                    <div class="goods-box" v-for="i in 10">
                        <el-skeleton-item variant="image" style="width: 228px; height: 228px; border-radius: 15px;" />
                        <el-skeleton-item variant="h3" style="width: 94%; margin: 10px 0;" />
                        <div style="width: 100%;text-align: left;">
                            <el-skeleton-item variant="text" style="width: 30%; margin-left: 6px;" />
                        </div>
                    </div>
                </div>
            </template>
            <template #default>
                <div class="goods-box" v-for="(item, index) in props.data.list" :key="index">
                    <div class="thumb-image">
                      <a-link :to="item.link.path"><img :src="getContentImage(item||{})" /></a-link>
                    </div>
                    <div class="goods-name wb3" v-if="props.data.is_title">
                        <a-link :to="item.link.path">{{ item.name || "" }}</a-link>
                    </div>
                    <div class="goods-price" v-if="props.data.is_price">￥{{ item.link.sell_price || "100" }}</div>
                </div>
            </template>
        </el-skeleton>
    </div>
</template>

<style lang="scss" scoped>
.goods-wrap {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 1200px;
    margin: 0px auto 0 auto;
    .goods-skeletion {

    }
    .goods-box {
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 45px;
        .thumb-image {
            img {
                width: 228px;
                height: 228px;
                border-radius: 10px;
            }
        }
        .goods-name {
            width: 100%;
            text-align: left;
            font-size: 14px;
            color: #0054b7;
            padding-left: 10px;
            margin-top: 14px;
            height: 40px;
            line-height: 20px;
            a {
                color: #0054b7;
                text-decoration: none;
                font-size: 14px;
                &:hover {
                    color: #dc143c;
                }
            }
        }
        .goods-price {
            width: 100%;
            text-align: left;
            color: #f00000;
            font-size: 18px;
            padding-left: 10px;
            margin-top: 12px;
        }
    }
}
</style>